<template>
    <pie-chart
        class="c-flexible-life-chart"
        :chartData="chartData"
        :chartOptions="chartOptions"
        :styles="myStyles"
    ></pie-chart>
</template>

<script>
var ComputedStyle = getComputedStyle(document.body);
import PieChart from "@/components/PieChart";
import { flexiblelife } from "@/mixins/flexiblelife";

export default {
    mixins: [flexiblelife],
    props: ["contractId", "myStyles"],
    data() {
        return {
            chartOptions: {
                // elements: {
                //     arc: {
                //         borderWidth: 0
                //     }
                // },
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                },
                tooltips: {
                    enabled: true,
                    mode: "label",
                    callbacks: {
                        label: function (tooltipItems, data) {
                            var label = data.labels[tooltipItems.index];
                            var value =
                                data.datasets[tooltipItems.datasetIndex].data[
                                    tooltipItems.index
                                ];
                            return label + " - " + value + "%";
                        },
                    },
                },
            },
        };
    },
    components: { PieChart },
    computed: {
        chartData() {
            let labels = [];
            let backgroundColor = [];
            let hoverBackgroundColor = [];
            let data = [];
            if (this.isVollwert) {
                labels = ["Ausgewogen", "Dynamisch", "Konservativ"];
                backgroundColor = [
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-ausgewogen"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-dynamisch"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-konservativ"
                    ),
                ];
                hoverBackgroundColor = [
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-ausgewogen"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-dynamisch"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-konservativ"
                    ),
                ];
                data = [
                    parseInt(this.fondsCategory65.prozent),
                    parseInt(this.fondsCategory100.prozent),
                    parseInt(this.fondsCategory40.prozent),
                ];
            } else if (this.isFlexibleLife20) {
                labels = [
                    "Ausgewogen",
                    "Dynamisch",
                    "Klassische Lebensversicherung",
                ];
                backgroundColor = [
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-ausgewogen"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-dynamisch"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-klassisch"
                    ),
                ];
                hoverBackgroundColor = [
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-ausgewogen"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-dynamisch"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-klassisch"
                    ),
                ];
                data = [
                    parseInt(this.fondsCategory70.prozent),
                    parseInt(this.fondsCategory100.prozent),
                    parseInt(this.flexiblelife.klvprozent),
                ];
            } else {
                labels = [
                    "Konservativ",
                    "Ausgewogen",
                    "Dynamisch",
                    "Klassische Lebensversicherung",
                ];
                backgroundColor = [
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-konservativ"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-ausgewogen"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-dynamisch"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-klassisch"
                    ),
                ];
                hoverBackgroundColor = [
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-konservativ"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-ausgewogen"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-dynamisch"
                    ),
                    ComputedStyle.getPropertyValue(
                        "--gangl-color-zukunft-klassisch"
                    ),
                ];
                data = [
                    parseInt(this.fondsCategory40.prozent),
                    parseInt(this.fondsCategory65.prozent),
                    parseInt(this.fondsCategory100.prozent),
                    parseInt(this.flexiblelife.klvprozent),
                ];
            }
            return {
                labels: labels,
                datasets: [
                    {
                        backgroundColor: backgroundColor,
                        hoverBackgroundColor: hoverBackgroundColor,
                        data: data,
                    },
                ],
            };
        },
    },
};
</script>

<style lang="scss"></style>
